/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Range_3mInputs */

const en_us2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const pt_br2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const es_419_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const pt_pt2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const fr_fr2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const de_de2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

const it_it2_exercise_sheet_range_3m = /** @type {(inputs: Exercise_Sheet_Range_3mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3M`)
};

/**
* | output |
* | --- |
* | "3M" |
*
* @param {Exercise_Sheet_Range_3mInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_range_3m = /** @type {((inputs?: Exercise_Sheet_Range_3mInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Range_3mInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_range_3m(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_range_3m(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_range_3m(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_range_3m(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_range_3m(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_range_3m(inputs)
	return en_us2_exercise_sheet_range_3m(inputs)
});
export { exercise_sheet_range_3m as "exercise-sheet.range_3m" }